import { apiClient } from '@/services/base'

import { IGetContactByDocumentMultiTenantRequest } from './interfaces/request'
import {
  IGetContactByDocumentMultiTenantResponse,
  IGetContactByDocumentMultiTenantErrorResponse,
} from './interfaces/response'

export const GetContactByDocumentMultiTenantService = async (
  request: IGetContactByDocumentMultiTenantRequest,
): Promise<IGetContactByDocumentMultiTenantResponse> => {
  const response = await apiClient.get('api/PasswordReset/MultiTenant', {
    params: request,
  })

  return response
}

export type {
  IGetContactByDocumentMultiTenantRequest,
  IGetContactByDocumentMultiTenantResponse,
  IGetContactByDocumentMultiTenantErrorResponse,
}
